import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["error", "loading"];
import { useMemo } from 'react';
import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { useFilterConfig } from './useFilterConfig';
export function useAppliedFilters() {
  const params = useSearchParams();
  const filterConfig = useFilterConfig();
  return useMemo(() => {
    const appliedFilters = [];

    // pull `error` and `loading` out, so we only have actual filters left
    const filters = _objectWithoutPropertiesLoose(filterConfig, _excluded);
    for (const filter of Object.values(filters)) {
      if (!filter) continue;
      const paramValues = params.getList(filter.field);
      if (paramValues.length === 0) continue;
      appliedFilters.push(Object.assign({}, filter, {
        values: paramValues
      }));
    }
    return appliedFilters;
  }, [filterConfig, params]);
}